<div
  class="basin-width-290x basin-display-flex basin-flex-column basin-justify-content-center basin-align-items-center basin-gap-1">
  <div class="basin-width-100 basin-display-flex basin-justify-content-end basin-align-items-center">
    <button pButton icon="symbol-close"
      styleClass="p-button-text basin-p-0 basin-width-min-content basin-color-true-white" (click)="toggleDetails()">
    </button>
  </div>
  <div
    class="basin-width-100 basin-background-true-white basin-py-5 basin-px-4 inspect-details-box basin-display-flex basin-flex-column basin-gap-4">
    <p class="basin-font-secondary basin-color-darkest-gray basin-font-size-20 basin-font-weight-bold">Details</p>
    <div class="basin-display-flex basin-flex-column basin-gap-3">
      <div class="basin-display-flex basin-flex-column">
        <div
          class="basin-display-flex basin-align-items-center basin-justify-content-space-between basin-color-dark-gray basin-font-size-14 basin-line-height-18">
          <p>Image X,Y</p>
          <p>{{ inspectDetails.imageXy }}</p>
        </div>
        <div
          class="basin-display-flex basin-align-items-center basin-justify-content-space-between basin-color-dark-gray basin-font-size-14 basin-line-height-18">
          <p>Northing</p>
          <p>{{ inspectDetails.utmY | number : "1.0-1" }} m</p>
        </div>
        <div
          class="basin-display-flex basin-align-items-center basin-justify-content-space-between basin-color-dark-gray basin-font-size-14 basin-line-height-18">
          <p>Easting</p>
          <p>{{ inspectDetails.utmX | number : "1.0-1" }} m</p>
        </div>
        <div
          class="basin-display-flex basin-align-items-center basin-justify-content-space-between basin-color-dark-gray basin-font-size-14 basin-line-height-18">
          <p>Elevation</p>
          <p>{{ inspectDetails.elevation | number : "1.0-1" }} m</p>
        </div>
      </div>
      <div class="basin-display-flex basin-flex-column">
        <div
          class="basin-display-flex basin-align-items-center basin-justify-content-space-between basin-color-dark-gray basin-font-size-14 basin-line-height-18">
          <p>Debris Depth</p>
          <p>{{ inspectDetails.debrisDepth | number : "1.0-2" }} m</p>
        </div>
        <div
          class="basin-display-flex basin-align-items-center basin-justify-content-space-between basin-color-dark-gray basin-font-size-14 basin-line-height-18">
          <p>Erosion</p>
          <p>{{ inspectDetails.erosion | number : "1.0-2" }} m</p>
        </div>
        <div
          class="basin-display-flex basin-align-items-center basin-justify-content-space-between basin-color-dark-gray basin-font-size-14 basin-line-height-18">
          <p>Deposition</p>
          <p>{{ inspectDetails.deposition | number : "1.0-2" }} m</p>
        </div>
        <div
          class="basin-display-flex basin-align-items-center basin-justify-content-space-between basin-color-dark-gray basin-font-size-14 basin-line-height-18">
          <p>Slope</p>
          <p>{{ inspectDetails.slope | number : "1.0-1" }}</p>
        </div>
        <div
          class="basin-display-flex basin-align-items-center basin-justify-content-space-between basin-color-dark-gray basin-font-size-14 basin-line-height-18">
          <p>D8 Aspect</p>
          <p>{{ inspectDetails.d8Aspect }}</p>
        </div>
        <div
          class="basin-display-flex basin-align-items-center basin-justify-content-space-between basin-color-dark-gray basin-font-size-14 basin-line-height-18">
          <p>D∞ Aspect</p>
          <p>{{ inspectDetails.dInfinitAspect }}°</p>
        </div>
        <div
          class="basin-display-flex basin-align-items-center basin-justify-content-space-between basin-color-dark-gray basin-font-size-14 basin-line-height-18">
          <p>Landslide #</p>
          <p>{{ inspectDetails.landslide }}</p>
        </div>
      </div>
      <div *ngIf="eventCountDetails.length > 0" class="basin-display-flex basin-flex-column">
        <div *ngFor="let item of eventCountDetails"
          class="basin-display-flex basin-align-items-center basin-justify-content-space-between basin-color-dark-gray basin-font-size-14 basin-line-height-18">
          <p>{{ item.label }}</p>
          <p>{{ item.value }}</p>
        </div>
      </div>
      <div *ngIf="inspectHasAgent" class="basin-display-flex basin-flex-column">
        <div *ngFor="let item of agentDetails"
          class="basin-display-flex basin-align-items-center basin-justify-content-space-between basin-color-dark-gray basin-font-size-14 basin-line-height-18">
          <p>{{ item.label }}</p>
          <p>{{ item.value }}</p>
        </div>
      </div>
    </div>
  </div>
</div>